import React, { useEffect, useState } from "react";
import exportImage from "../../../asset/Images";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import InputField from "../../InputField";
import { useMutation } from "react-query";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../popupmodal/Popup";

export default function Branch() {
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      status: "Active",
    },
  });
  const { state } = useLocation();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API INTEGRATION START
  const { mutate, isSuccess, reset, isLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/branches/addbranch`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        reset();
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add branch",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // POST API END

  // UPDATE API START
  const { mutate: updateApi, isLoading: updateLoading } = useMutation(
    async (postdata) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/branches/${state && state?.id}`,
          postdata
        );
        return response.data;
      } catch (error) {
        console.error("Error while updating data:", error);
        throw error;
      }
    },
    {
      onSuccess: (val) => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add branch",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // UPDATE API END

  useEffect(() => {
    setValue("branchName", state?.branchName);
    setValue("no", state?.no);
    setValue("street", state?.street);
    setValue("locality", state?.locality);
    setValue("city", state?.city);
    setValue("pincode", state?.pincode);
    setValue("phoneNo", state?.phoneNo);
    setValue("altPhoneNo", state?.altPhoneNo);
    setValue("gstIn", state?.gstIn);
    setValue("status", state?.status || "Active");
  }, [state, setValue]);

  const onSubmit = (data) => {
    let formData = {
      branchName: data?.branchName,
      no: data?.no,
      street: data?.street,
      locality: data?.locality,
      city: data?.city,
      pincode: data?.pincode,
      phoneNo: data?.phoneNo,
      altPhoneNo: data?.altPhoneNo,
      gstIn: data?.gstIn,
      status: data?.status,
    };
    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">
              {state?.id ? <>Edit Branch</> : <>Add Branch</>}
            </div>
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Branch Name</label>
                    <Controller
                      control={control}
                      name="branchName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">No</label>
                    <Controller
                      control={control}
                      name="no"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                          // placeholder="DD/MM/YYYY"
                        />
                        // <DateField {...field} commonInputCss="commonInputCss" />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Street</label>
                    <Controller
                      control={control}
                      name="street"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Locality</label>
                    <Controller
                      control={control}
                      name="locality"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">City</label>
                    <Controller
                      control={control}
                      name="city"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Pin code</label>
                    <Controller
                      control={control}
                      name="pincode"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Phone Number</label>
                    <Controller
                      control={control}
                      name="phoneNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="tel"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Alter Number</label>
                    <Controller
                      control={control}
                      name="altPhoneNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="tel"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">GST IN</label>
                    <Controller
                      control={control}
                      name="gstIn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Status</label>
                    <Controller
                      control={control}
                      name="status"
                      defaultValue="Active"
                      render={({ field }) => (
                        <select {...field} className="commonInputCss">
                          {/* No empty option, Active is default */}
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn " type="submit">
                  {isLoading || updateLoading ? (
                    <>
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Branch Added Successfully!"
        updatemessage="Branch Updated Successfully!"
        state={state?.id}
        navigateUrl="/setting/branchView"
      />
    </>
  );
}
